import React, { Component } from 'react';
import './logoSection.css';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';

export default class BiosSection extends Component {
  render() {
    return (
      <div className="full-width sectionContainer">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Bios" />
        <SectionPageHeader description="Professional headshots and bios help represent our team consistently across the website, decks, and external materials. Use the approved formats to ensure a polished and unified presentation." />
        <div className="max-width-container small-bottom-margin">
          <div className="section-padding no-top-padding">
            <div className="">
              <div className="row middle">
                <div
                  className="small-12 medium-6 centered-text full-height small-padding">
                  <img src={'design/vp-headshots.jpg'} className="full-width small-bottom-margin" alt="Example of headshots" />
                  <p className="subheading tiny-bottom-margin">{'VP Headshots'} </p>
                  <a className="downloadText" href="design/vp-headshots.zip">
                    Download
                    <span className="material-symbols-rounded">download</span>
                  </a>
                </div>
                <div
                  className="small-12 medium-6 centered-text full-height small-padding">
                  <img src={'design/team-bios.jpg'} className="full-width small-bottom-margin" alt="Example of team bios" />
                  <p className="subheading tiny-bottom-margin">{'Team Bios'} </p>
                  <a className="downloadText" href="design/team-bios.docx">
                    Download
                    <span className="material-symbols-rounded">download</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
